//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-35px'
    },
    left: {
      type: String,
      default: '10px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.initBarChart()
    // }, 1000)
    this.$nextTick(function () {});
  },
  methods: {
    initBarChart: function initBarChart(title, value) {
      var option = {
        // backgroundColor: "#38445E",
        grid: {
          left: '12%',
          top: '25%',
          bottom: '20%',
          right: '8%'
        },
        //提示框
        tooltip: {
          trigger: 'axis',
          formatter: "{b} : {c}",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        xAxis: {
          data: title,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 129, 109, 0.1)',
              width: 1 //这里是为了突出显示加上的

            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 9
            }
          }
        },
        yAxis: [{
          show: false,
          splitNumber: 2,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 129, 109, 0.1)',
              width: 1 //这里是为了突出显示加上的

            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          splitArea: {
            areaStyle: {
              color: 'rgba(255,255,255,.5)'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 129, 109, 0.1)',
              width: 0.5,
              type: 'dashed'
            }
          }
        }],
        series: [{
          name: 'hill',
          type: 'pictorialBar',
          barCategoryGap: '0%',
          symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
          label: {
            show: true,
            position: 'top',
            distance: 15,
            color: '#DB5E6A',
            fontWeight: 'bolder',
            fontSize: 20
          },
          itemStyle: {
            normal: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(232, 94, 106, .8)' //  0%  处的颜色

                }, {
                  offset: 1,
                  color: 'rgba(232, 94, 106, .1)' //  100%  处的颜色

                }],
                global: false //  缺省为  false

              }
            },
            emphasis: {
              opacity: 1
            }
          },
          data: value,
          z: 10
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};